<template>
  <div>
    <base-header
      class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
      style="
        min-height: 600px;
        background-size: cover;
        background-position: center top;
      "
    >
      <!-- Mask -->
      <span class="mask bg-gradient-success opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-8 col-md-10">
            <h1 class="display-2 text-white">Hola Usuario</h1>
            <p class="text-white mt-0 mb-5">
              Aquí puede ver y actualizar el seguimiento de su rutina.
            </p>
            
            <router-link :to="{ name: 'Ver Rutina', params: { rutinaId: rutinaId}}" class="btn btn-info"><span>Volver a la rutina</span></router-link>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-12 order-xl-1">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">Diario de la rutina</h3>
                </div>
                <div class="col text-right">
                  <base-button type="default" size="sm" @click="modals.modal1 = true; add_ejercicio.fecha = new Date().getTime();">Añadir registro</base-button>
                  <modal :show.sync="modals.modal1">
                      <h5 slot="header" class="modal-title" id="modal-title-default">Añadir registro al diario de la rutina</h5>
                      <form @submit.prevent="onFormSubmit">
                            <br>
                            <label for="ejercicio_category" class="form-control-label">Ejercicio</label>
                            <Select2 id="ejercicio_id" class="form-control-alternative" v-model="add_ejercicio.ejercicio_id" :options="allEjercicios" :settings="{ width:'100%', closeOnSelect: 'true' }"  @change="myChangeEvent($event)" @select="mySelectEvent($event)" />
                            <small v-if="ejercicio_null" style="color:red;">Debe seleccionar un ejercicio</small>
                            <base-input
                                alternative=""
                                label="Series"
                                placeholder="Series"
                                type="number"
                                input-classes="form-control-alternative"
                                v-model="add_ejercicio.series"/>
                            <base-slider v-model="add_ejercicio.series" :options="{step: 1}" :range="{min: 0, max: 10}"></base-slider>

                            <base-input
                                alternative=""
                                label="Repeticiones"
                                placeholder="Repeticiones"
                                type="number"
                                input-classes="form-control-alternative"
                                v-model="add_ejercicio.repeticiones"/>
                            <base-slider v-model="add_ejercicio.repeticiones" :options="{step: 1}" :range="{min: 0, max: 25}"></base-slider>

                            <base-input
                                alternative=""
                                label="Peso (Kg)"
                                placeholder="Peso"
                                type="number"
                                input-classes="form-control-alternative"
                                v-model="add_ejercicio.peso"/>
                            <base-slider v-model="add_ejercicio.peso" :options="{step: 1}" :range="{min: 0, max: 100}"></base-slider>

                            <base-input
                                v-if="show_esfuerzo == 'true'"
                                alternative=""
                                label="Esfuerzo"
                                placeholder="Esfuerzo"
                                type="number"
                                input-classes="form-control-alternative"
                                v-model="add_ejercicio.esfuerzo"/>
                            <base-slider v-if="show_esfuerzo == 'true'" v-model="add_ejercicio.esfuerzo" :options="{step: 1}" :range="{min: 0, max: 100}"></base-slider>

                            <base-input
                                v-if="show_rpe == 'true'"
                                alternative=""
                                label="RPE"
                                placeholder="RPE"
                                type="number"
                                input-classes="form-control-alternative"
                                v-model="add_ejercicio.rpe"/>
                            <base-slider v-if="show_rpe == 'true'" v-model="add_ejercicio.rpe" :options="{step: 1}" :range="{min: 0, max: 10}"></base-slider>

                            <base-input
                                alternative=""
                                label="Descanso"
                                placeholder="Descanso"
                                input-classes="form-control-alternative"
                                v-model="add_ejercicio.descanso"/>
                            <label for="ejercicio_category" class="form-control-label">Fecha</label>
                            <small v-if="date_null" style="color:red;">Debe introducir una fecha válida</small>
                            <base-input addon-left-icon="ni ni-calendar-grid-58">
                              <flat-picker
                                slot-scope="{ focus, blur }"
                                @on-open="focus"
                                @on-close="blur"
                                :config="{ allowInput: true, enableTime: true, dateFormat: 'd-m-Y H:i:s' }"
                                class="form-control datepicker"
                                v-model="add_ejercicio.fecha"
                              >
                              </flat-picker>
                            </base-input>
                            <button id="save" class="btn btn-primary btn-block">Añadir</button>
                        </form>
                        
                        <template slot="footer">

                            <base-button type="link" class="ml-auto" @click="modals.modal1 = false">Cancelar</base-button>
                        </template>
                      
                  </modal>
                </div>
              </div>
            </div>
            <template>
              <tabs>
                <tab-pane title="Seguimiento"><div class="col table-responsive">
                  <div class="row">
                    
                    <div class="col-9 col-sm-9 col-lg-6"><base-input addon-left-icon="ni ni-calendar-grid-58">
                              <flat-picker
                                slot-scope="{ focus, blur }"
                                @on-open="focus"
                                @on-close="blur"
                                label="Buscar..."
                                :config="{ allowInput: true,}"
                                class="form-control datepicker"
                                v-model="buscar"
                              >
                              </flat-picker>
                            </base-input>
                    </div>
                    <div class="col-3 col-sm-3 col-lg-3"><button class="btn btn-primary btn-block" @click="showDia"><i class="fas fa-search"></i></button></div>
                  </div>    
                  <br>
                  <table class="table align-items-center table-flush">
                    <tr>
                      <th></th>
                      <th>Ejercicio</th>
                      <th>Fecha</th>
                      <th>Series</th>
                      <th>Repeticiones</th>
                      <th>Peso</th>
                      <th>Descanso</th>
                      <th v-if="show_esfuerzo == 'true'">Esfuerzo</th>
                      <th v-if="show_rpe == 'true'">RPE</th>
                      
                    </tr>
                    <tr v-for="element in registros" :key="element.id">
                        <td class="text-left">
                              <base-button block size="sm" type="danger" class="btn btn-danger btn-block" @click="deleteRegistro(element.id)">
                                <span>-</span>
                              </base-button> 
                        </td>
                        <td><router-link :to="{ name: 'Ver Ejercicio', params: { ejercicioId: element.ejercicio_id}}">{{ element.ejercicio_name}}</router-link></td>
                        <td>{{element.fecha.toDate().toLocaleDateString('es-ES')}}</td>
                        <td>{{element.series}}</td>
                        <td>{{element.repeticiones}}</td>
                        <td>{{element.peso}} Kg</td>
                        <td>{{element.descanso}}</td>
                        <td v-if="show_esfuerzo == 'true'">{{element.esfuerzo}}</td>
                        <td v-if="show_rpe == 'true'">{{element.rpe}}</td>
                    </tr>
                    <tr>
                      <td colspan="6" v-if="registros.length < 1"> No hay elementos para mostrar</td>
                    </tr>
                  </table>
              </div>
              <hr>
              <button class="page-item page-link" @click="mostrarTodos">Mostrar todos</button>
              </tab-pane>
              <tab-pane title="Ejercicios"><h6 class="heading-small text-muted mb-4">Ejercicios</h6>
                <base-dropdown id="indice_semana" position="left" v-if="detectMob()">
                        <base-button slot="title" type="primary" class="dropdown-toggle">
                            Índice
                        </base-button>
                            <a class="dropdown-item" href="#dilluns">Lunes</a>
                            <a class="dropdown-item" href="#dimarts">Martes</a>
                            <a class="dropdown-item" href="#dimecres">Miércoles</a>
                            <a class="dropdown-item" href="#dijous">Jueves</a>
                            <a class="dropdown-item" href="#divendres">Viernes</a>
                            <a class="dropdown-item" href="#dissabte">Sábado</a>
                        </base-dropdown>
              <div class="row" id="container-ejercicios">
                        <div class="col-12 col-sm-12 col-lg-6 col-xl"><span id="dilluns">Lunes</span>
                            <ul id="1">
                                <li style="list-style:none;" v-for="(item, index) in lunes" :key="index">
                                    <ejercicio-card 
                                        :series="item.series"
                                        :repeticiones="item.repeticiones"
                                        :descanso="item.descanso"
                                        :ejercicio_id="item.ejercicio_id">
                                    </ejercicio-card>
                                </li>

                            </ul>
                        </div>
                        <div class="col-12 col-sm-12 col-lg-6 col-xl"><span id="dimarts">Martes</span>
                            <ul id="2">
                                <li style="list-style:none;" v-for="(item, index) in martes" :key="index">
                                    <ejercicio-card 
                                        :series="item.series"
                                        :repeticiones="item.repeticiones"
                                        :descanso="item.descanso"
                                        :ejercicio_id="item.ejercicio_id">
                                    </ejercicio-card>
                                </li>
                            </ul>
                        </div>

                        <div class="col-12 col-sm-12 col-lg-6 col-xl"><span id="dimecres">Miércoles</span>
                            <ul id="3">
                                <li style="list-style:none;" v-for="(item, index) in miercoles" :key="index">
                                    <ejercicio-card 
                                        :series="item.series"
                                        :repeticiones="item.repeticiones"
                                        :descanso="item.descanso"
                                        :ejercicio_id="item.ejercicio_id">
                                    </ejercicio-card>
                                </li>
                            </ul>
                        </div>
                        <div class="col-12 col-sm-12 col-lg-6 col-xl"><span id="dijous">Jueves</span>
                            <ul id="4">

                                <li style="list-style:none;" v-for="(item, index) in jueves" :key="index">
                                    <ejercicio-card 
                                        :series="item.series"
                                        :repeticiones="item.repeticiones"
                                        :descanso="item.descanso"
                                        :ejercicio_id="item.ejercicio_id">
                                    </ejercicio-card>
                                </li>

                            </ul>
                        </div>
                        <div class="col-12 col-sm-12 col-lg-6 col-xl"><span id="divendres">Viernes</span>
                            <ul id="5">

                                <li style="list-style:none;" v-for="(item, index) in viernes" :key="index">
                                    <ejercicio-card 
                                        :series="item.series"
                                        :repeticiones="item.repeticiones"
                                        :descanso="item.descanso"
                                        :ejercicio_id="item.ejercicio_id">
                                    </ejercicio-card>
                                </li>

                            </ul>
                        </div>
                        <div class="col-12 col-sm-12 col-lg-6 col-xl col-xl"><span id="dissabte">Sábado</span>
                            <ul id="6">

                                <li style="list-style:none;" v-for="(item, index) in sabado" :key="index">
                                    <ejercicio-card 
                                        :series="item.series"
                                        :repeticiones="item.repeticiones"
                                        :descanso="item.descanso"
                                        :ejercicio_id="item.ejercicio_id">
                                    </ejercicio-card>
                                </li>
                            </ul>
                        </div>
                    </div></tab-pane>
              </tabs>
              
              
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from '../../firebaseDb';
import { auth } from '../../firebaseDb';
import Select2 from 'v-select2-component';
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import EjercicioCard from '@/components/EjercicioCard';
export default {
    name: "seguimiento-rutina",
    props: {
            rutinaId: {
            type: String,
            defalut: ""
            }
    },
    components:{
      Select2,
      flatPicker,
      EjercicioCard,
    },
    data() {
        return {
            user: auth.currentUser,
            lunes: [],
            martes: [],
            miercoles: [],
            jueves: [],
            viernes: [],
            sabado: [],
            registros: [],
            currentDay:"",
            i: 0,
            modals:{
              modal1: false,
              modal2: false
            },
            add_ejercicio:{
              descanso: "",
              dia: "",
              ejercicio_id: "",
              repeticiones: 0, 
              series: 0,
              peso: 0,
              fecha: new Date(),
              esfuerzo: 0,
              rpe: 0,  
            },
            allEjercicios: [],
            buscar: "",
            ejercicio_null: false,
            date_null: false,
            show_esfuerzo: "false",
            show_rpe: "false",
        };
    },
    created: function() {
    var self = this
    db.collection('ejercicios').get()
        .then(snapshot => {
            snapshot.forEach(doc => {
                let item = doc.data()
                item.id = doc.id
                item.text = doc.data().ejercicio_name
                this.allEjercicios.push(item)
            })
        })
    this.creado();
    db.collection('users').doc(this.user.uid).get()
      .then(function(doc){
        if(doc.exists){          
          try{

            let esfuerzo = doc.data().use_esfuerzo
            self.show_esfuerzo = esfuerzo;

            let rpe = doc.data().use_rpe
            self.show_rpe = rpe;
          
          }catch(error){
            console.log(error)
          }
        }
      });
    db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutinaId).collection('ejercicios').where('dia','==', 'lunes').orderBy("order", "asc").get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let item = doc.data()
          item.id = doc.id
          item.text = doc.id
          item.series = parseInt(doc.data().series, 10);
          item.repeticiones = parseInt(doc.data().repeticiones, 10);
          this.lunes.push(item)
        })
      })
    db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutinaId).collection('ejercicios').where('dia','==', 'martes').orderBy("order", "asc").get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let item = doc.data()
          item.id = doc.id
          item.series = parseInt(doc.data().series, 10);
          item.repeticiones = parseInt(doc.data().repeticiones, 10);
          this.martes.push(item)
        })
      })
      db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutinaId).collection('ejercicios').where('dia','==', 'miercoles').orderBy("order", "asc").get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let item = doc.data()
          item.id = doc.id
          item.series = parseInt(doc.data().series, 10);
          item.repeticiones = parseInt(doc.data().repeticiones, 10);
          this.miercoles.push(item)
        })
      })
      db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutinaId).collection('ejercicios').where('dia','==', 'jueves').orderBy("order", "asc").get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let item = doc.data()
          item.id = doc.id
          item.series = parseInt(doc.data().series, 10);
          item.repeticiones = parseInt(doc.data().repeticiones, 10);
          this.jueves.push(item)
        })
      })
      db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutinaId).collection('ejercicios').where('dia','==', 'viernes').orderBy("order", "asc").get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let item = doc.data()
          item.id = doc.id
          item.series = parseInt(doc.data().series, 10);
          item.repeticiones = parseInt(doc.data().repeticiones, 10);
          this.viernes.push(item)
        })
      })
      db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutinaId).collection('ejercicios').where('dia','==', 'sabado').orderBy("order", "asc").get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let item = doc.data()
          item.id = doc.id
          item.series = parseInt(doc.data().series, 10);
          item.repeticiones = parseInt(doc.data().repeticiones, 10);
          this.sabado.push(item)
        })
      })
  },
  methods: {
    creado(){
        let hoy = new Date(new Date().getFullYear(),new Date().getMonth() , new Date().getDate());
        let marrana = new Date(new Date().getFullYear(),new Date().getMonth() , new Date().getDate() + 1);
        db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutinaId).collection('seguimiento').where('createdAt','>=', hoy).where('createdAt','<=', marrana).orderBy('createdAt', 'desc').get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            let item = doc.data()
            item.id = doc.id
            if (this.i == 0){
              this.currentDay = item.fecha
              this.i++
            }
            let ejersisio = this.allEjercicios.find(element => element.id === item.ejercicio_id);
            item.ejercicio_name = ejersisio.ejercicio_name
            this.registros.push(item)
          })
        })
    },
    onFormSubmit(event) {
      event.preventDefault();
      if (this.add_ejercicio.ejercicio_id == '' || this.add_ejercicio.ejercicio_id == null) {
        this.ejercicio_null = true;
      }else{
        this.ejercicio_null = false;
      }
      if (this.add_ejercicio.fecha == '' || this.add_ejercicio.fecha == null) {
        this.date_null = true;
      }else{
        this.date_null = false;
      }
      
      if(this.ejercicio_null == false && this.date_null == false) {
        this.ejercicio_null = false;
        console.log(this.add_ejercicio.fecha)
        try {
          this.add_ejercicio.fecha = this.add_ejercicio.fecha.substring(6,10)+'-'+this.add_ejercicio.fecha.substring(3,5)+'-'+this.add_ejercicio.fecha.substring(0,2)+' '+this.add_ejercicio.fecha.substring(11,16)
        } catch (error) {
          console.log(error);
        }
        db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutinaId).collection('seguimiento')
          .add({
            descanso: this.add_ejercicio.descanso,
            createdAt: new Date (this.add_ejercicio.fecha),
            ejercicio_id: this.add_ejercicio.ejercicio_id,
            repeticiones: this.add_ejercicio.repeticiones, 
            series: this.add_ejercicio.series,
            peso: this.add_ejercicio.peso,
            esfuerzo: this.add_ejercicio.esfuerzo,
            rpe: this.add_ejercicio.rpe, 
            fecha: new Date (this.add_ejercicio.fecha),
          }).then(() => {
            
            this.add_ejercicio.ejercicio_id = '';
            this.add_ejercicio.fecha = new Date().getTime();
            this.registros = [];
            this.creado();
            this.modals.modal1 = false;
            this.track_add();
          }).catch((error) => {
            console.log(error);
          });
      }
      
        
    },
    deleteRegistro(id){
        if (window.confirm("¿Está seguro de eliminar este registro?")) {
          db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutinaId).collection('seguimiento').doc(id).delete().then(() => {
              console.log("Document deleted!");
              this.registros = [];
              this.creado();
              this.track_delete();
          })
          .catch((error) => {
              console.error(error);
          })
        }
      },   
    detectMob() {
    return (window.innerWidth <= 800);
    },  
    mostrarTodos(){
      this.registros = [];
      db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutinaId).collection('seguimiento').orderBy('createdAt', 'desc').get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let item = doc.data()
          item.id = doc.id
          if (this.i == 0){
            this.currentDay = item.fecha
            this.i++
          }
          let ejersisio = this.allEjercicios.find(element => element.id === item.ejercicio_id);
          item.ejercicio_name = ejersisio.ejercicio_name
          this.registros.push(item);
        })
      })
    },
    showDia(){
      console.log(this.buscar);
      this.registros = [];
      let dia = new Date(this.buscar);
      let dia_siguiente = new Date(this.buscar);
      dia_siguiente.setDate(dia_siguiente.getDate() + 1);
      console.log(dia_siguiente)
      db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutinaId).collection('seguimiento').where('createdAt','>=', dia).where('createdAt','<=', dia_siguiente).orderBy('createdAt', 'desc').get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            let item = doc.data()
            item.id = doc.id
            if (this.i == 0){
              this.currentDay = item.fecha
              this.i++
            }
            let ejersisio = this.allEjercicios.find(element => element.id === item.ejercicio_id);
            item.ejercicio_name = ejersisio.ejercicio_name
            this.registros.push(item)
          })
          this.track_search();
        })
    },
    track_add() {
        this.$gtag.event("added_seguimiento", {
          'event_category': "rutina",
          'event_label': "seguimiento_added",
          'value': 1
        })
    },
    track_delete() {
        this.$gtag.event("deleted_seguimiento", {
          'event_category': "rutina",
          'event_label': "seguimiento_deleted",
          'value': 1
        })
    },
    track_search() {
        this.$gtag.event("search_seguimiento", {
          'event_category': "rutina",
          'event_label': "seguimiento_search",
          'value': 1
        })
    },   
  }

}
</script>

<style>
.por-arriba{
      position: absolute;  
}
@media (min-width: 1200px) and ( max-width: 1536px) {
  #container-ejercicios{
    overflow-x: auto;
    white-space: nowrap;
    display: block;
  }
}
</style>